import { Controller } from "stimulus"
export default class extends Controller {
  updateUrl() {
    const href = this.element.getAttribute("href")
    const incoming = new URL(href, window.location.origin)
    const current  = new URL(window.location.href)
    current.searchParams.set("step", incoming.searchParams.get("step"))
    window.history.pushState({}, "", current.toString())
  }
}